<template>
    <div class="detail">
        <div class="addDeive" v-if="JSON.stringify(currentLoop)=='{}'">请添加设备</div>
        <div class="detail" v-else>
            <div class="titles">设备详情
                <!-- <span @click="submitDeviceUpdate(0)" class="save" v-if="editmode">保存</span> -->
                <!-- <el-button type="primary"  @click="submitDeviceUpdate(0)" class="save" v-if="editmode" >保存</el-button> -->
                <span ref="save" @click="submitDeviceUpdate(0)" class="save" v-if="editmode" ><el-button type="primary"  >保存</el-button></span>
                <el-button type="primary" class="add" v-if="editmode" @click="submitDeviceUpdate(1)" :disabled="!firstcheck">新增此参数设备</el-button>
                <!-- <span class="add" v-if="editmode" @click="submitDeviceUpdate(1)">新增此参数设备</span> -->
            </div>
            <div class="name">{{currentLoop.deviceName}}</div>
            <div class="device row-center">
                <div class="imgshow">
                    <img :src="currentInfo.device_img" alt="">
                    <el-upload
                    v-if="editmode"
                    class="avatar-uploader"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                        <img v-if="currentInfo.device_img" :src="currentInfo.device_img" class="avatar">
                        <div class="addupload" v-else>上传图片</div>
                    </el-upload>
                </div>
                <div class="map"><div id="map-container" style="height:100%;width:100%"></div></div>
            </div>
            <div class="info  row-center">
                <div class="baseinfo ">
                    <div class="tt">设备信息</div>
                    <div class="list"><i v-if="editmode">*</i>类型：
                        <span v-if="!editmode">{{device_type_name}}</span>
                        <span v-else>
                            <el-select v-model="device_type_name" placeholder="请选择">
                                <el-option
                                v-for="item in typeOptions"
                                :key="item.deviceTypeName"
                                :label="item.deviceTypeName"
                                :value="item.deviceTypeName">
                                </el-option>
                            </el-select>
                        </span>
                    </div>
                    <!-- <div class="list">厂家：<span></span></div> -->
                    <div class="list"><i v-if="editmode">*</i>品牌：<span v-if="!editmode">{{currentInfo.device_brand_name}}</span>
                    <span v-else>
                        <el-select v-model="currentInfo.device_brand_name" placeholder="请选择">
                            <el-option
                            v-for="item in brandOptions"
                            :key="item.deviceBrandName"
                            :label="item.deviceBrandName"
                            :value="item.deviceBrandName">
                            </el-option>
                        </el-select>
                        </span>
                    </div>
                    <div class="list"><i v-if="editmode">*</i>型号：<span v-if="!editmode">{{currentInfo.device_model_name}}</span>
                    <span v-else>
                        <el-select v-model="currentInfo.device_model_name" placeholder="请选择" >
                            <el-option
                            v-for="item in modelOptions"
                            :key="item.deviceModelName"
                            :label="item.deviceModelName"
                            :value="item.deviceModelName">
                            </el-option>
                        </el-select>
                    </span>
                    </div>
                    <div class="tt">基本信息</div>
                    <div class="list"><i v-if="editmode">*</i>设备编号：<span v-if="!editmode"  class="u-line-1" style="max-width:70%">{{currentInfo.device_number}}</span>
                    <span v-else><el-input v-model="currentInfo.device_number" placeholder="请输入内容"></el-input></span>
                    </div>
                    <div class="list"><i v-if="editmode">*</i>设备名称：<span v-if="!editmode"  class="u-line-1" style="max-width:70%">{{currentLoop.deviceName}}</span>
                        <span v-else><el-input v-model="currentLoop.deviceName" placeholder="请输入内容"></el-input></span>
                    </div>
                    <div class="list">所属项目：<span  class="u-line-1" style="max-width:70%">{{projectInfo.projectName}}</span></div>
                    <div class="list"><i v-if="editmode">*</i>所属电站：<span v-if="!editmode"  class="u-line-1" style="max-width:70%">{{currentInfo.area_name}}</span>
                        <span v-else>
                            <el-select v-model="currentInfo.area_name" placeholder="请选择">
                                <el-option
                                v-for="item in areaOptions"
                                :key="item.areaName"
                                :label="item.areaName"
                                :value="item.areaName">
                                </el-option>
                            </el-select>
                        </span>
                    </div>
                    <div class="list">安装位置：<span class="u-line-1" style="max-width:70%">{{projectInfo.projectAddress}}</span></div>
                    <div class="list"><i v-if="editmode">*</i>出厂日期：<span v-if="!editmode">{{currentInfo.production_date}}</span>
                    <span v-else>
                        <el-date-picker
                        format="yyyy/MM/dd"
                        value-format="yyyy/MM/dd"
                        v-model="currentInfo.production_date"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                    </span>
                    </div>
                    <div class="list"><i v-if="editmode">*</i>投运日期：<span v-if="!editmode">{{currentInfo.commissioning_date}}</span>
                        <span v-else>
                        <el-date-picker
                        format="yyyy/MM/dd"
                        value-format="yyyy/MM/dd"
                        v-model="currentInfo.commissioning_date"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                    </span>
                    </div>
                    <div class="list"><i v-if="editmode">*</i>上次检修日期：<span v-if="!editmode">{{currentInfo.last_overhaul_date}}</span>
                        <span v-else>
                        <el-date-picker
                        format="yyyy/MM/dd"
                        value-format="yyyy/MM/dd"
                        v-model="currentInfo.last_overhaul_date"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                    </span>
                    </div>
                    <div class="list"><i v-if="editmode">*</i>上次预检日期：<span v-if="!editmode">{{currentInfo.next_pre_inspection_date}}</span>
                        <span v-else>
                        <el-date-picker
                        format="yyyy/MM/dd"
                        value-format="yyyy/MM/dd"
                        v-model="currentInfo.next_pre_inspection_date"
                        type="date"
                        placeholder="选择日期">
                        </el-date-picker>
                    </span>
                    </div>
                </div>
                <div class="parameter" id="equipmentLedger">
                    <div class="tt">技术参数</div>
                    <div class="warm" v-if="!device_type_name&&editmode">
                        <i class="el-icon-warning"></i>请先选择设备类型
                    </div>
                    <div v-else-if="editmode">
                        <div class="box" v-for="(item,index) in parameter" :key="index" >
                            <div class="title">
                                <span><el-input v-model="item.name" placeholder="请输入内容"></el-input></span>
                                <i class="el-icon-delete" @click="deleteGroup(item,index)"></i>
                                <i class="el-icon-arrow-down" @click="showGroup(item,index)" v-if="item.show"></i>
                                <i class="el-icon-arrow-up" @click="showGroup(item,index)" v-else></i>
                            </div>
                            <div class="body" v-if="item.show">
                                <div class="list" v-for="(elm,index1) in item.children"  :key="index1">
                                    <span><el-input v-model="elm.name" placeholder="请输入内容"></el-input><el-input v-model="elm.val" placeholder="请输入内容"></el-input></span>
                                    <i class="el-icon-delete" @click="deleteItem(elm,index,index1)"></i>
                                </div>
                                <div class="add" @click="addParameter(index)">
                                    <i class="el-icon-circle-plus-outline"></i>添加参数
                                </div>
                            </div>
                        </div>
                        <div class="addgorup" @click="addGroup"><i class="el-icon-circle-plus-outline"></i>添加参数分组</div>
                    </div>
                    <div  v-else>
                        <el-collapse v-model="activeNames" >
                            <!-- <el-collapse-item :title="key+'参数'" :name="index" v-for="(item,key,index) in currentInfo.device_details">
                                <div class="content-item" v-for="(value,name) in item">
                                    <div class="content-item-name">{{name}}：</div>
                                    <div class="content-item-value">{{value}}</div>
                                </div>
                            </el-collapse-item> -->
                            
                            <el-collapse-item :title="item.name+'参数'" :name="index" v-for="(item,index) in parameter">
                                <div class="content-item" v-for="(elm,name) in item.children">
                                    <div class="content-item-name">{{elm.name}}：</div>
                                    <div class="content-item-value">{{elm.val}}</div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>      
                    </div>

                    <div class="" v-if="!editmode&&labelData!=''">
                        <div class="tt" style="margin:5px 0">关联回路</div>
                        <div class="labelData"  style="background: #f5f7f9;height: 40px;line-height: 40px;padding-left: 10px;color: #666666;font-size: 13px;">{{ labelData }}</div>
                    </div>
                    <div class="circuit" v-if="(currentLoop.deviceTypeId=='38'||currentLoop.deviceTypeId=='37'||currentLoop.deviceTypeId=='36'||currentLoop.deviceTypeId=='52'||(currentLoop.deviceName2&&currentLoop.deviceName2.indexOf('断路器')>-1))&&editmode">
                        <div class="tt" style="margin:5px 0">关联回路</div>
                        <div class="mytrees">
                            <el-select v-model="labelData" placeholder="请选择" clearable  :popper-append-to-body="false" style="width:100%" ref="multiSelect">
                                <el-option :value="selectTree" class="setstyle" disabled>
                                    <el-tree 
                                    ref="tree"
                                    :data="list" 
                                    default-expand-all 
                                    :props="defaultProps" 
                                    @node-click="handleNodeClick"
                                    :expand-on-click-node="false">
                                        <div class="custom-tree-node" slot-scope="{ node, data }" :class="{ 'checked': (data.loopId === loopInfo.loopId)&&loopInfo.loopId }">
                                            <div class="land">
                                                <span class="names" :title="data.loopName">{{ data.loopName }}</span>
                                            </div>
                                        </div>
                                    </el-tree>
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { deviceAll,GetWireByDeviceID,DeviceTypeAll,DeviceBrandAll,DeviceModelAll,GET_AREAS,getLookup,DeviceUpdate,DeviceAdd,loopTreeList,breakList,loopUpdate } from "../../api/power";
import { UPLOAD_IMAGE} from "../../api/upload";
import {
  dateFormat,
} from "../../util/DateUtil";
import {loadBMap} from '@/util/map'
import { json } from "body-parser";
  export default {
    props:{
        currentLoop:Object,
        editmode:Boolean,
        isupadte:Boolean
    },
    data() {
      return {
        labelData: "",
        selectTree: [],
        activeNames: [0,1,2,3,4,5],
        currentInfo:{  //设备详情
            device_model_name:""
        },
        id:0,
        id1:0,
        parameter:[ ],
        typeOptions: [],  //类型
        modelOptions:[],  //型号
        brandOptions:[],  //品牌
        areaOptions:[],
        firstcheck:true,
        list:[], //回路列表
        loopInfo:{ //关联回路
            loopId:0
        },
        defaultProps: {
            children: 'childrenLoopList',
            label: 'loopName'
        },
        device_type_name:""
      };
    },
    computed:{
        projectInfo(){
            return this.$store.state.project.projectInfo
        },
        EnterpriseInfo(){
            return this.$store.state.project.EnterpriseInfo
        },
        deviceTypeObj(){  //设备类型
            return this.typeOptions.filter(e=>e.deviceTypeName==this.device_type_name)[0]
        },
        areaObj(){  //设备类型
            return this.areaOptions.filter(e=>e.areaName==this.currentInfo.area_name)[0]
        },
        brandObj(){  //品牌
            return this.brandOptions.filter(e=>e.deviceBrandName==this.currentInfo.device_brand_name)[0]
        },
        modelObj(){  //型号
            return this.modelOptions.filter(e=>e.deviceModelName==this.currentInfo.device_model_name)[0]
        }
    },
    watch:{
        currentLoop(n,o){
            // if(n.deviceId!=undefined){
                this.currentInfo = {}
                this.device_type_name = ""
                this.initGetWireByDeviceID();
                this.getbreakList();
                if(this.editmode){
                    this.getTypeAll();  
                    this.getBrandAll();  
                    this.getModelAll(); 
                }
                // loadBMap('initBaiduMapScript');
                
            // }
            // if(this.editmode){  
            //     this.submitDeviceUpdate(0,o)
            // }
        },
        device_type_name(n,o){
            console.log(n,o,"n")
            if(n!=undefined&&n!=this.currentInfo.device_type_name&&this.editmode){
                this.getLookupFun()
            }
        },
        editmode(n,o){
            this.getLoopList()
            if(n){
                this.getbreakList()
                this.getTypeAll();  
                this.getBrandAll();  
                this.getModelAll(); 
            }
            
            // loadBMap('initBaiduMapScript');
        },
        isupadte(n,o){
            if(n){
                this.$refs.save.dispatchEvent(new MouseEvent('click'));
                // this.submitDeviceUpdate(0)   
            }
        }
    },
    mounted(){
        const that = this
        
        /* 百度地图 */
        window.initBaiduMapScript = () =>{
           let map = new BMap.Map('map-container');
            //创建地址解析器实例
            var myGeo = new BMap.Geocoder();
            // 将地址解析结果显示在地图上，并调整地图视野
            myGeo.getPoint(that.projectInfo.projectAddress, function(points){
                if(points){
                    map.centerAndZoom(points, 17);
                    map.addOverlay(new BMap.Marker(points, {title: that.projectInfo.projectAddress}))

                    var opts = {
                        width: 180,     // 信息窗口宽度
                        height: 100,    // 信息窗口高度
                        title: "<p style='color:#FD4238;font-size:14px'>"+that.$store.getters.selProjectInfo.projectName+"</p>"  // 信息窗口标题
                    }
                    let operatorTel = that.EnterpriseInfo.operatorTel
                    let adr = that.$store.getters.selProjectInfo.projectAddress
                    let firmEmail = that.EnterpriseInfo.firmEmail
                    var sContent = `<p>地址：`+adr+`</p><p>电话：`+operatorTel+`</p><p>邮箱：`+firmEmail+`</p>`;
                    var infoWindow = new BMap.InfoWindow(sContent, opts);  // 创建信息窗口对象
                    map.openInfoWindow(infoWindow, map.getCenter());        // 打开信息窗口
                }else{
                    // alert('您选择的地址没有解析到结果！');
                }
            })
        } 

        setTimeout(function(){
            loadBMap('initBaiduMapScript');
        },800)


        that.getLoopList()
        // this.deviceId = this.currentLoop.deviceId
        GET_AREAS().then(res => {
            this.areaOptions = res.data.data.areas
        })
        if(this.currentLoop.deviceId!=undefined){
            that.initGetWireByDeviceID();
            that.getbreakList();
            this.getTypeAll();  
            this.getBrandAll();  
            this.getModelAll(); 
        } 
    },
    methods:{
        async updateLoop(data){
            if(this.currentLoop.deviceTypeId=='37'||this.currentLoop.deviceTypeId=='36'||this.currentLoop.deviceTypeId=='38'||this.currentLoop.deviceTypeId=='52'||(this.currentLoop.deviceName2&&this.currentLoop.deviceName2.indexOf('断路器')>-1)){ //是否是断路器
                let loopObj = {
                    loopId:this.loopInfo.loopId,
                    breakDeviceId:this.labelData!=''?this.currentLoop.deviceId:""
                }
                if(data&&data.deviceId){
                    loopObj.breakDeviceId = data.deviceId
                }
                if(this.loopInfo.loopId){
                    let result = await loopUpdate(loopObj);
                    if(result.data.status){
                        
                    }else{
                        this.$message.error(result.data.errMsg);
                    }
                }
                
            }
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.loopName.indexOf(value) !== -1;
        },
        handleNodeClick(data){
            this.labelData = data.loopName;//展示部分
            this.loopInfo = data;//传参---id
            setTimeout(() => {
                this.$refs.multiSelect.blur()
            }, 50)

        },
        async getLoopList(loop){
            // let result = await loopList({projectId:this.$store.getters.projectId});
            let result = await loopTreeList({projectId:this.$store.getters.projectId});
            let data = result.data.data
            let list = []
            data.forEach(item=>{
                item.loopName = item.areaName,
                item.add = true
                item.loopId = 0
                list.push(item)
            })
            this.list = list
        },
        async submitDeviceUpdate(type,data){
            let obj = {
                areaId:this.areaObj?this.areaObj.areaId:"",
                projectId:this.$store.getters.projectId,
                lookupId:this.currentLoop.lookupId,
                deviceBrandId:this.brandObj?this.brandObj.deviceBrandId:"",
                deviceClassId:this.deviceTypeObj?this.deviceTypeObj.deviceClassId:"",
                deviceTypeId:this.deviceTypeObj?this.deviceTypeObj.deviceTypeId:"",
                deviceId:type==0?this.currentLoop.deviceId:"",
                deviceImg:this.currentInfo.device_img,
                deviceModelId:this.modelObj?this.modelObj.deviceModelId:"",
                deviceName:this.currentLoop.deviceName,
                lastOverhaulDate:this.currentInfo.last_overhaul_date?this.currentInfo.last_overhaul_date:"",
                nextPreInspectionDate:this.currentInfo.next_pre_inspection_date?this.currentInfo.next_pre_inspection_date:"",
                deviceDetails:{},
                commissioningDate:this.currentInfo.commissioning_date?this.currentInfo.commissioning_date:"",
                deviceNumber:this.currentInfo.device_number,
                productionDate:this.currentInfo.production_date?""+this.currentInfo.production_date+"":"",
                breakDeviceId:this.loopInfo.loopId
            }

            if(this.currentLoop.deviceTypeId!='36'&&this.currentLoop.deviceTypeId!='37'&&this.currentLoop.deviceTypeId!='38'&&this.currentLoop.deviceTypeId!='52'){
                obj.breakDeviceId = ""
            }
            // if(data){
            //     obj.lookupId = data.lookupId,
            //     obj.deviceId =data.deviceId
            // }
            // obj.deviceDetails = JSON.stringify(this.parameter)
            this.parameter.forEach(item=>{
                obj.deviceDetails[item.name] = {}
                if(item.children.length>0){
                    item.children.forEach(elm=>{
                        obj.deviceDetails[item.name][elm.name] = elm.val
                    })
                }
            })
            obj.deviceDetails = JSON.stringify(obj.deviceDetails)
            if(type==0){
                if(this.currentLoop.deviceId==0){
                    obj.deviceName = this.currentLoop.deviceName
                    let result = await DeviceAdd(obj);
                    if(result.data.status){
                        this.$message.success('新增成功！');
                        this.$emit("updateDevice",result.data.data.result)
                    }else{
                        this.$message.error(result.data.errMsg);
                    }
                    this.updateLoop(result.data.data.result)
                }else{
                    let result = await DeviceUpdate(obj);
                    if(result.data.status){
                        this.$message.success('保存成功！');
                    }else{
                        this.$message.error(result.data.errMsg);
                    }
                    this.updateLoop(result.data.data.result)
                }
            }else if(type==1){
                if(this.firstcheck){
                    this.firstcheck = false
                    obj.deviceName = obj.deviceName+"-副本"
                    let result = await DeviceAdd(obj);
                    if(result.data.status){
                        this.$message.success('新增成功！');
                        this.$emit("updateDevice",result.data.data.result)
                        let self = this
                        setTimeout(function(){
                            self.firstcheck = true
                        },1000)
                    }else{
                        this.$message.error(result.data.errMsg);
                    }
                }
                this.updateLoop(result.data.data.result)
            }

            
            this.$emit("getisupadte",false)
        },
        //获取技术参数
        async getLookupFun(){
            if(this.deviceTypeObj==undefined){
                return false
            }
            let obj = {
                lookupValue:this.deviceTypeObj.deviceTypeId,
            }
            let result = await getLookup(obj);
            if(result.data.status&&result.data.data.result.length>0){
                let data = result.data.data.result[0]
                data.attribute1 = JSON.parse(data.attribute1)
                this.parameter = []
                let key = Object.keys(data.attribute1)
                key.forEach(item=>{
                    let children = []
                    for(let i in data.attribute1[item]){
                        children.push({
                            name:i,
                            val:data.attribute1[item][i]
                        })
                    }
                    this.parameter.push({
                        name:item,
                        show:true,
                        children:children
                    })
                })
            }else{
                this.parameter = []
            }
        },
         //获取全部类型
        async getTypeAll(){
            this.typeOptions = []
            let obj = {
                lookupId:this.currentLoop.lookupId
            }
            let result = await DeviceTypeAll(obj);
            if(result.data.status){
                let data = result.data.data.all
                this.typeOptions = data
            }
        },
         //获取全部品牌
        async getBrandAll(){
            // this.brandOptions = []
            let result = await DeviceBrandAll();
            if(result.data.status){
                let data = result.data.data.result
                this.brandOptions = data
            }
        },
         //获取全部型号
        async getModelAll(){
            this.modelOptions = []
            let result = await DeviceModelAll();
            if(result.data.status){
                let data = result.data.data.result
                this.modelOptions = data
            }
        },
        showGroup(item,index){
            item.show = !item.show
        },
        deleteGroup(item,index){
            this.parameter.splice(index,1)
            let len = this.parameter.length
            if(this.parameter[len-1].id){
                this.id1 = this.parameter[len-1].id
            }else{
                this.id1 = 0
            }
        },
        deleteItem(item,index,index1){
            this.parameter[index].children.splice(index1,1)
            let len = this.parameter[index].children.length
            if(this.parameter[index].children[len-1].id){
                this.id = this.parameter[index].children[len-1].id
            }else{
                this.id = 0
            }
            
        },
        addGroup(){
            this.id1++
            this.parameter.push({name:"未命名分组"+this.id1,id:this.id1,children:[],show:true})
        },
        addParameter(index){
            this.id++
            this.parameter[index].children.push({name:"未命名参数"+this.id,id:this.id})
        },
        async getbreakList(){
            let id = this.currentLoop.deviceId
            let result = await breakList({deviceId:id});
            if(result.data.status){
                if(result.data.data.loopList.length>0){ //关联回路
                    this.labelData = result.data.data.loopList[0].loopName;
                    this.loopInfo = result.data.data.loopList[0];
                }else{
                    this.labelData = ""
                    this.loopInfo = {}
                }
            }
        },
        async initGetWireByDeviceID(){
            let id = this.currentLoop.deviceId
            let result = await GetWireByDeviceID(id);
            if(result.data.status){
                let data = result.data.data.device
                this.currentInfo = data
                this.device_type_name = data.device_type_name
                if(data.device_details){ //如果有值
                    data.device_details = JSON.parse(data.device_details)
                    this.parameter = []
                    let key = Object.keys(data.device_details)
                    key.forEach(item=>{
                        let children = []
                        for(let i in data.device_details[item]){
                            children.push({
                                name:i,
                                val:data.device_details[item][i]
                            })
                        }
                        this.parameter.push({
                            name:item,
                            show:true,
                            children:children
                        })
                    })
                }
            }else{
                this.currentInfo = {}
                this.parameter = []
            }
        },
        handleAvatarSuccess(res, file) {
            this.currentInfo.device_img = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isPNG = file.type === "image/png";

            if (!isJPG && !isPNG) {
                this.$message.error("上传头像图片只能是 JPG和PNG 格式!");
                return false
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
                return false
            }
            UPLOAD_IMAGE(file).then((res) => {
                if (res.data.status) {
                    this.currentInfo.device_img = res.data.data.path
                }
            });
            return false
        }
    }
  };
</script>

<style scoped lang="less">
.labelData{
    background: rgb(245, 247, 249);
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    color: rgb(102, 102, 102);
    font-size: 13px;  
}
.addDeive{
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #666666;
    margin-top: 38%;
}
/deep/.mytrees{
   .checked{
    color: #0D94FF;
   }
}
.setstyle {
	min-height: 200px;
	padding: 0 !important;
	margin: 0;
	overflow: auto;
	cursor: default !important;
}
.warm{
    height: 38px;
    line-height: 35px;
    background: rgba(109,200,236,0.2);
    border: 2px solid #6DC8EC;
    border-radius: 4px;
    font-size: 16px;
    color: #6DC8EC;
    padding:0 10px;
    margin-top: 10px;
    
    i{
        color:#6DC8EC;
        font-size:20px;
        margin-right: 5px;
        vertical-align: middle;
    }
}
.avatar-uploader{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /deep/.el-upload{
        width: 100%;
        height: 100%;
    }
}

.detail{
    // flex: 1;
    // padding-left: 24rem;
    height: 100%;
    .titles{
        height: 40px;
        font-size: 18rem;
        font-weight: bold;
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        .add,.save{
            padding:0 10px;
            height: 40rem;
            line-height: 40rem;
            // background: #0D94FF;
            border-radius: 4px;
            text-align: center;
            color: #ffffff;
            font-size: 14rem;
            display: inline-block;
            float: right;
            min-width: 80px;
            margin-left: 10px;
            cursor: pointer;
            .el-button{
                padding:0 10px;
                height: 40rem;
                line-height: 40rem;
                // background: #0D94FF;
                border-radius: 4px;
                text-align: center;
                color: #ffffff;
                font-size: 14rem;
                display: inline-block;
                float: right;
                min-width: 80px;
                cursor: pointer;
            }
        }
    }
    .name{
        font-size: 18rem;
        font-weight: bold;
        color: #0D94FF;
        line-height: 40px;
    }
    .device{
        justify-content: space-between;
        .imgshow{
            width: 49%;
            // .w(420);
            height: 200px;
            background: #F4F6F8;
            text-align: center;
            position: relative;
            img{
                max-width: 100%;
                max-height: 100%;
            }
            .addupload{
                font-size: 36rem;
                color: #999999;
                line-height: 200px;
            }
        }
        .map{
            width: 49%;
            // .w(420);
            height: 200px;
            background: #ffffff;
        }
    }
    .info{
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 10px;
        height: calc(100% - 300px);
        .tt{
                height: 48rem;
                line-height: 48rem;
                background: #DCE2EA;
                font-size: 16rem;
                padding: 0 12px;
                font-weight: bold;
            }
        .baseinfo{
            // .w(420);
            width: 49%;
            height: 100%;
            overflow: auto;
            .list{
                height: 44px;
                line-height: 44px;
                background: #F5F7F9;
                color: #666666;
                font-size: 16rem;
                padding: 0 12px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.15);
                span{
                    float: right
                }
                i{
                    color: red;
                }
                .el-input,.el-select{
                    width:220px
                }
            }
            
        }
    }
    .parameter{
        // .w(420);
        width: 49%;
        height: 100%;
        overflow: auto;
        .box{
            margin-bottom: 10px;
            span{
                // display: inline-block;
            }
            .title{
                height: 37px;
                line-height: 37px;
                background: rgba(13,148,255,0.08);
                border: 1px solid #CCCCCC;
                // border-bottom: 0;
                padding-left: 10px;
                /deep/.el-input__inner{
                    background: transparent;
                    height: 30px;
                    border-radius:0
                }
            }
            .list{
                height: 44px;
                line-height: 44px;
                background: #F5F7F9;
                border: 1px solid #CCCCCC;
                border-top: 0;
                padding-left: 10px;
                /deep/.el-input{
                    width: 40%;
                }
            }
            .el-icon-delete{
                color:#FD4238;
                font-size: 18px;
                margin: 0 10px;
                cursor: pointer;
            }
            .el-icon-arrow-down,.el-icon-arrow-up{
                cursor: pointer;
                font-size: 22px;
            }
            /deep/.el-input{
                width: 80%;
            }
            /deep/.el-input__inner{
                height: 36px;
                border-radius:0
            }
        }
        .add{
            height: 46px;
            line-height: 46px;
            font-size: 14px;
            color: #666666;
            padding: 0 15px;
            background: #F5F7F9;
            border: 1px solid #CCCCCC;
            border-top: 0;
            cursor: pointer;
            i{
                color:#269A99;
                font-size: 22px;
                vertical-align: middle;
                margin-right: 5px;
            }
        }
        .addgorup{
            height: 46px;
            line-height: 46px;
            font-size: 14px;
            color: #666666;
            background: #ECF7FF;
            padding: 0 15px;
            cursor: pointer;
            margin-top: 10px;
            i{
                color:#269A99;
                font-size: 22px;
                vertical-align: middle;
                margin-right: 5px;
            }
        }

    }
}
.content-item {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    justify-content: space-between;
    color: #666666;
    height: 48rem;
    
    .content-item-name {
        // .w(144);
        display: flex;
        align-items: center;
        padding-left: 12px;
    }

    .content-item-value {
        // .w(355);
        display: flex;
        justify-content: center;
        align-items: center;
        padding-right: 12px;
    }
}
</style>